<template>
  <div class=" datatableWrapper">
    <div class=" datatableWrapperInner">
      <div class="row">
        <div class="col  col-12 ">
        <div class="col col-sm-12 col-md-6" v-if="options && options.isTextSearch===false">
        </div>
        <div class="col col-sm-12 col-md-6" v-if="(!options) || options.isTextSearch!==false">
          <div class="row form-group">
            <div class="col col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-right Xpl20" style="">
              <label for="select" class=" form-control-label">{{ $t('TableDatatableJs.search') }}</label>
            </div>
            <div class="col col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 input-group Xpl20">
              <div class="input-group">
              <span :title="$t('TableDatatableJs.titletagmemory')" v-if="!isKeepsettings" class="input-group-addonX btn btn-primary" v-on:click="keepsettingsChange"><i
                class="fa fa-minus"></i> {{ $t('TableDatatableJs.isNotKeepsettings') }}</span>
                <span :title="$t('TableDatatableJs.titletagmemory')" v-if="isKeepsettings" class="input-group-addonX btn btn-success" v-on:click="keepsettingsChange"><i
                  class="fa fa-check"></i> {{ $t('TableDatatableJs.isKeepsettings') }}</span>
                <InputText style="flex: 1 1 0;" hasToKeyboard="auto" id="text-input" v-model="searchText" title="" placeholder="" dataLayout="t" className="form-control w100i d-block"/>
                <!--<input v-model="searchText" type="text" id="text-input" name="searchText" placeholder="" class="form-control">-->
                <span v-on:click="(searchText='')" class="input-group-addon cursor"><i class="fa fa-times"></i></span>

              </div>
            </div>
          </div>
        </div>
        <div class="col col-sm-12 col-md-6">
          <div class="row form-group">
            <div class="col col-12 col-sm-2 col-md-4 col-lg-4 col-xl-4 text-right ">
              <label for="text-input" class=" form-control-label">{{ $t('TableDatatableJs.perpage') }}</label>
            </div>
            <div class="col col-12 col-sm-10 col-md-8 col-lg-8 col-xl-8 ">
              <table class="w100">
                <tr>
                  <td class="w1">
              <span :title="$t('TableDatatableJs.titletagmemory')" v-if="!isKeepsettingsPager" class="input-group-addonX btn btn-primary" v-on:click="keepsettingsPagerChange"><i
                class="fa fa-minus"></i> {{ $t('TableDatatableJs.isNotKeepsettings') }}</span>
                    <span :title="$t('TableDatatableJs.titletagmemory')" v-if="isKeepsettingsPager" class="input-group-addonX btn btn-success" v-on:click="keepsettingsPagerChange"><i
                      class="fa fa-check"></i> {{ $t('TableDatatableJs.isKeepsettings') }}</span>

                  </td>
                  <td class="w100">
                    <select id="select" class="form-control" v-model="perPageStr" name="perPageStr">
                      <option value="3">3</option>
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="500">500</option>
                    </select>

                  </td>
                </tr>

              </table>

            </div>
          </div>
        </div>
      </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="col-lg-12 col-xl-5 pl10">
                    <span class="dataTables_info" role="status"
                          aria-live="polite">{{$t('TableDatatableJs.countMaxPageText')}}:  {{this.data.length}} ({{((this.actualPage * this.perPage) - this.perPage)}} - {{(this.actualPage * this.perPage)}})
                    </span>
            <!--<span class="text-left">-->
            <!--<span v-if="!isKeepsettings" class="btn btn-secondary" v-on:click="keepsettingsChange"><i class="fa fa-times"></i> {{ $t('TableDatatableJs.isNotKeepsettings') }}</span>-->
            <!--<span v-if="isKeepsettings" class="btn btn-primary" v-on:click="keepsettingsChange"><i class="fa fa-check"></i> {{ $t('TableDatatableJs.isKeepsettings') }}</span>-->
            <!--</span>-->

          </div>
          <div class="col-lg-12 col-xl-7 ">
            <div class="dataTables_paginate paging_simple_numbers">
              <ul class="pagination">
                <li v-on:click="prev()" class="paginate_button page-item previous "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0"
                                                                                       class="page-link">{{$t('TableDatatableJs.prev')}}</a></li>
                <li v-on:click="setActualPage(actualPage - 500)" v-if="(this.actualPage>500)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="1" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage > 500) ? (this.actualPage - 500) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage - 50)" v-if="(this.actualPage>50)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)" aria-controls="bootstrap-data-table"
                                                                                                                                                  data-dt-idx="1" tabindex="0"
                                                                                                                                                  class="page-link">{{(this.actualPage > 50) ? (this.actualPage - 50) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage - 3)" v-if="(this.actualPage>3)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="1"
                                                                                                                                tabindex="0"
                                                                                                                                class="page-link">{{(this.actualPage > 3) ? (this.actualPage - 3) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage - 2)" v-if="(this.actualPage>2)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="2"
                                                                                                                                tabindex="0"
                                                                                                                                class="page-link">{{(this.actualPage > 2) ? (this.actualPage - 2) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage - 1)" v-if="(this.actualPage>1)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="3"
                                                                                                                                tabindex="0"
                                                                                                                                class="page-link">{{(this.actualPage > 1) ? (this.actualPage - 1) : ""}}</a>
                </li>
                <li v-if="(true)" class="paginate_button page-item active"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="4" tabindex="0"
                                                                              class="page-link">{{this.actualPage}}</a></li>
                <li v-on:click="setActualPage(actualPage + 1)" v-if="((this.actualPage < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="5" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage < this.countMaxPage) ? (this.actualPage + 1) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage + 2)" v-if="((this.actualPage+1 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                      aria-controls="bootstrap-data-table"
                                                                                                                                                      data-dt-idx="6" tabindex="0"
                                                                                                                                                      class="page-link">{{(this.actualPage + 1 < this.countMaxPage) ? (this.actualPage + 2) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage + 3)" v-if="((this.actualPage+2 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                      aria-controls="bootstrap-data-table"
                                                                                                                                                      data-dt-idx="6" tabindex="0"
                                                                                                                                                      class="page-link">{{(this.actualPage + 2 < this.countMaxPage) ? (this.actualPage + 3) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage + 50)" v-if="((this.actualPage+50 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                        aria-controls="bootstrap-data-table"
                                                                                                                                                                        data-dt-idx="6" tabindex="0"
                                                                                                                                                                        class="page-link">{{(this.actualPage + 50 < this.countMaxPage) ? (this.actualPage + 51) : ""}}</a>
                </li>
                <li v-on:click="setActualPage(actualPage + 500)" v-if="((this.actualPage+500 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                          aria-controls="bootstrap-data-table"
                                                                                                                                                                          data-dt-idx="6" tabindex="0"
                                                                                                                                                                          class="page-link">{{(this.actualPage + 500 < this.countMaxPage) ? (this.actualPage + 501) : ""}}</a>
                </li>
                <li v-on:click="next()" class="paginate_button page-item next"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0"
                                                                                  class="page-link">{{$t('TableDatatableJs.next')}}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col" v-for="(headRow, index) in headWithFilter" v-on:click="headRowClick(headRow, index)" class="cursor">
              <i v-bind:class="{
                            'shorter-icon fa fa-sort-asc':(headRow.sortDirection==='asc'),
                         'shorter-icon fa fa-sort-desc':(headRow.sortDirection==='desc'),
                         'shorter-icon fa fa-sort':(typeof headRow.sortDirection==='undefined')
                        }"></i>
              {{$t(headRow.title)}}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(dataRow, index) in dataRange(((this.actualPage*this.perPage)-this.perPage), this.perPage)">

            <td v-for="(headRow, index2) in head" :style="headRow.styletd" :class="(headRow.cbclasstd)?headRow.cbclasstd(dataRow[headRow.key], 'type', dataRow, 'meta'):headRow.classtd">

              <template v-if="headRow.linkurl">
                            <span :style="headRow.styletext" :class="headRow.classtext"><router-link :to="{ path: headRow.linkurl+'/'+dataRow.id}" :class="headRow.linkclass"><i
                              :class="headRow.linkiconclass"></i> {{$t(headRow.linktext)}}</router-link></span>
              </template>


              <template v-if="headRow.displayFn">
                <template v-if="headRow.displayFn && headRow.displayFn(dataRow[headRow.key],'type',dataRow,'meta')">
                            <span :style="headRow.styletext" :class="headRow.classtext"><a href="javascript:void 0;" v-on:click="function g(e){headRow.linkfn(e,dataRow[headRow.key],'type',dataRow,'meta')}"
                                                                                           :class="headRow.linkclass"><i :class="headRow.linkiconclass"></i>
                                {{$t(headRow.linktext)}}</a></span>

                </template>
              </template>

              <template v-if="!headRow.displayFn">
                <template v-if="headRow.linkfn">
                            <span :style="headRow.styletext" :class="headRow.classtext"><a href="javascript:void 0;" v-on:click="function g(e){headRow.linkfn(e,dataRow[headRow.key],'type',dataRow,'meta')}"
                                                                                           :class="headRow.linkclass"><i :class="headRow.linkiconclass"></i>
                                {{$t(headRow.linktext)}}</a></span>
                </template>
              </template>

              <!--<template v-if="headRow.render">-->
              <!--XX{{headRow.render(dataRow[headRow.key], "??type", headRow, "??meta")}}-->
              <!--</template>-->


              <template v-if="headRow.roweditor">
                <!--{{              dataRow.id}}-->
                <!--{{ modelRowIsEditing }}-->
                <template v-if="modelRowIsEditing[dataRow.id]">
                  <button type="button" class="btn btn-primary btn-sm" v-on:click="doSave($event,index, headRow, dataRow)">
                    <i class="fa fa-save"></i> {{$t('global.save')}}
                  </button>
                </template>
                <template v-if="!modelRowIsEditing[dataRow.id]">
                  <button type="button" class="btn btn-primary btn-sm" v-on:click="doEdit($event,index, headRow, dataRow)">
                    <i class="fa fa-edit"></i> {{$t('global.edit')}}
                  </button>
                </template>

              </template>

              <template v-if="headRow.editable && headRow.rowedittype==='datetimepicker'">
                <div class="DatetimepickerBpContainer">
                  <InputText type="DatetimepickerBp"
                             id="dt_transfer" name="headRow.checkboxData.fieldKey" v-model="modelRow[dataRow.id][headRow.key]" v-validate="{date_format:'yyyy-MM-dd', required:false}" hasToKeyboard="auto" value=""
                             :title="$t('Document.dt')"
                             placeholder="..." dataLayout="tn" className="form-control mandatoryX" :hasError="errors.has('headRowcheckboxDatafieldKey[index]')"
                             :disabled="String( (String(modelRowIsEditing[dataRow.id]) !== '1'))"
                             :readonly="String( (String(modelRowIsEditing[dataRow.id]) !== '1'))"
                  />
                </div>
              </template>
              <template v-if="headRow.editable && headRow.rowedittype==='checkbox'">
                <input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="modelRow[dataRow.id][headRow.key]" class="checkboxBig w200px" v-on:change="chkbClick($event,index, headRow, dataRow)"
                       :disabled="String(modelRowIsEditing[dataRow.id]) !== '1'"
                       :readonly="String(modelRowIsEditing[dataRow.id]) !== '1'"
                >
              </template>

              <template v-if="!headRow.linkfn&&!headRow.linkurl&&!headRow.editable&&!headRow.roweditor">
                <template v-if="!headRow.render">
                  <template v-if="!headRow.i18Key">
                    <span :style="headRow.styletext" :class="headRow.classtext">{{dataRow[headRow.key]}}</span>
                  </template>
                  <template v-if="headRow.i18Key">
                    <span :style="headRow.styletext" :class="headRow.classtext">{{$t(headRow.i18Key + "." + dataRow[headRow.key]) }}</span>
                  </template>
                </template>
                <template v-if="headRow.render">
                  <template>
                    <span :style="headRow.styletext" :class="headRow.classtext">{{headRow.render(dataRow[headRow.key], "type", dataRow, "meta")}}</span>
                  </template>

                </template>

              </template>

            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col">
        <div class="col-lg-12 col-xl-5">
          <div class="dataTables_info" role="status"
               aria-live="polite">{{$t('TableDatatableJs.countMaxPageText')}}:  {{this.data.length}} ({{((this.actualPage * this.perPage) - this.perPage)}} - {{(this.actualPage * this.perPage)}})
          </div>
        </div>
        <div class="col-lg-12 col-xl-7">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li v-on:click="prev()" class="paginate_button page-item previous "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0"
                                                                                     class="page-link">{{$t('TableDatatableJs.prev')}}</a></li>
              <li v-on:click="setActualPage(actualPage - 500)" v-if="(this.actualPage>500)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                  aria-controls="bootstrap-data-table"
                                                                                                                                                  data-dt-idx="1" tabindex="0"
                                                                                                                                                  class="page-link">{{(this.actualPage > 500) ? (this.actualPage - 500) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 50)" v-if="(this.actualPage>50)" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)" aria-controls="bootstrap-data-table"
                                                                                                                                                data-dt-idx="1" tabindex="0"
                                                                                                                                                class="page-link">{{(this.actualPage > 50) ? (this.actualPage - 50) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 3)" v-if="(this.actualPage>3)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="1"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 3) ? (this.actualPage - 3) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 2)" v-if="(this.actualPage>2)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="2"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 2) ? (this.actualPage - 2) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage - 1)" v-if="(this.actualPage>1)" class="paginate_button page-item "><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="3"
                                                                                                                              tabindex="0"
                                                                                                                              class="page-link">{{(this.actualPage > 1) ? (this.actualPage - 1) : ""}}</a>
              </li>
              <li v-if="(true)" class="paginate_button page-item active"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="4" tabindex="0"
                                                                            class="page-link">{{this.actualPage}}</a></li>
              <li v-on:click="setActualPage(actualPage + 1)" v-if="((this.actualPage < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                  aria-controls="bootstrap-data-table"
                                                                                                                                                  data-dt-idx="5" tabindex="0"
                                                                                                                                                  class="page-link">{{(this.actualPage < this.countMaxPage) ? (this.actualPage + 1) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 2)" v-if="((this.actualPage+1 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="6" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage + 1 < this.countMaxPage) ? (this.actualPage + 2) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 3)" v-if="((this.actualPage+2 < this.countMaxPage))" class="paginate_button page-item "><a href="javascript:void(0)"
                                                                                                                                                    aria-controls="bootstrap-data-table"
                                                                                                                                                    data-dt-idx="6" tabindex="0"
                                                                                                                                                    class="page-link">{{(this.actualPage + 2 < this.countMaxPage) ? (this.actualPage + 3) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 50)" v-if="((this.actualPage+50 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                      aria-controls="bootstrap-data-table"
                                                                                                                                                                      data-dt-idx="6" tabindex="0"
                                                                                                                                                                      class="page-link">{{(this.actualPage + 50 < this.countMaxPage) ? (this.actualPage + 51) : ""}}</a>
              </li>
              <li v-on:click="setActualPage(actualPage + 500)" v-if="((this.actualPage+500 < this.countMaxPage))" class="paginate_button page-item pagination-extra"><a href="javascript:void(0)"
                                                                                                                                                                        aria-controls="bootstrap-data-table"
                                                                                                                                                                        data-dt-idx="6" tabindex="0"
                                                                                                                                                                        class="page-link">{{(this.actualPage + 500 < this.countMaxPage) ? (this.actualPage + 501) : ""}}</a>
              </li>
              <li v-on:click="next()" class="paginate_button page-item next"><a href="javascript:void(0)" aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0"
                                                                                class="page-link">{{$t('TableDatatableJs.next')}}</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div>
        <div v-if="hasXlsField">
          <button type="button" class="btn btn-primary btn-sm" v-on:click="exportToXls">
            <i class="fa fa-dot-circle-o"></i>
            <template v-if="options && options.exportToXlsKey">
              {{$t(options.exportToXlsKey)}}
            </template>
            <template v-if="!options || !options.exportToXlsKey">
              {{$t('global.exportToXls')}}
            </template>
          </button>
        </div>


      </div>


    </div>
  </div>
</template>
<script>
  import InputText from '@/components/InputText.vue';
  import hash from "object-hash";
  import XLSX from 'xlsx';
  import OSheetManager from '@/helper/oSheetManager';
  import oCell from '@/helper/oCell';
  import moment from 'moment';
  import {set, get} from 'lodash';
  /**
   * The data and head Arrays are more or less same as jquery datatable params
   *
   * Here is an example. It uses link, and i18 translate too
   *
   data: [{"id": "1", "user_name": "value"}, {"id": "2", "user_name": "value2"}],
   head: [
   {
     title: "users.dttitle" ,
     data: "id",
     link: true,
     linkurl: "useredit",
     linkiconclass: "menu-icon fa fa-edit",
     linktext: "users.linktext",
   },
   {
     key: "user_name",
     title: "Title"
   }
   ,{
      key: "user_role",
      title: "Jogkör",
      i18Key:"user_role"
    }
   ]
   *
   */
  export default {
    name: 'TableDatatableJs',
    props: {
      data: Array, // Array of object - Key, value pair
      options: Object, // object - Key, value pair {exportToXlsKey: .. } Possible key: exportToXlsKey
      head: Array, // Array of object - Key, value contains head property
    },
    data(){
      return {
        modelRow: {},
        headRowcheckboxDatafieldKey: [],
        modelRowIsEditing: {},
        set: set,
        get: get,
        key: 0,
        sortDirection: void 0,
        isKeepsettings: false,
        isKeepsettingsPager: false,
        searchText: "",
        perPage: 50,
        perPageStr: "50",
        actualPage: 1,
        countMaxPage: 0,
        dataFiltered: [],
        headWithFilter: [],
        headHash: "",
        hasXlsField: false
      }
    },
    mounted() {
      const modul = this;
      modul.headHash = hash(modul.head);
      modul.headWithFilter = modul.head;
      modul.dataFiltered = modul.data;

      /*      const moduldata=[];
       Array.prototype.forEach.call(modul.data, function (e, i) {
       moduldata.push(e);
       });
       modul.dataFiltered = moduldata;
       const modulhead=[];
       Array.prototype.forEach.call(modul.head, function (e, i) {
       modulhead.push(e);
       });
       modul.headWithFilter = modulhead;*/
    },
    watch: {
      headHash: function (newdata, olddata) {
        const modul = this;
        Array.prototype.forEach.call(modul.headWithFilter, function (e2, i2) {
          if (e2['xlsfield']) {
            modul.hasXlsField = true;
          }
        });
      },
      head: function (newdata, olddata) {
        const modul = this;
        modul.headWithFilter = newdata;
      },
      options: function (newdata, olddata) {
        const modul = this;
      },
      data: function (newdata, olddata) {
        const modul = this;
//        modul.dataFiltered = newdata;
        modul.dataFiltered = modul.filterData(modul.searchText);
      },
      modelRow: function (newdata, olddata) {
        const modul = this;
//        modul.dataFiltered = modul.filterData(modul.searchText);
      },
      countMaxPage: function (newdata, olddata) {
        const modul = this;
        if (newdata !== olddata) {
//          console.log("-------------------------új mennyiség--------------")
        }
      },
      searchText: function (newdata, olddata) {
        const modul = this;
        if (modul.searchText.length > 0) {
          const data = modul.filterData(newdata);
          modul.dataFiltered = data;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", newdata);
        } else {
          modul.dataFiltered = modul.data;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", "");
        }
      },
      dataFiltered: function (newdata, olddata) {
        const modul = this;
        if (newdata !== olddata) {
          this.calculateCountPage();
        }
        if (this.actualPage > this.countMaxPage) {
          if (this.countMaxPage === 0) {
            this.actualPage = 1;
          } else {
            this.actualPage = this.countMaxPage;
          }
        }
        modul.loadDefaultData();
      }
      , perPageStr: function (newdata, olddata) {
        const modul = this;
        this.perPage = Number(this.perPageStr);
      }
      , perPage: function (newdata, olddata) {
        const modul = this;
        this.calculateCountPage();
        if (this.actualPage >= this.countMaxPage) {
          this.actualPage = this.countMaxPage;
        }
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "perPage", newdata)
      }
    },
    methods: {
      doSave: function (e, index, headRow, dataRow) {
        const modul = this;
        this.$nextTick(() => {
          headRow.cbSave(e, index, headRow, dataRow).then(function (result) {
            modul.modelRowIsEditing[dataRow.id] = 0;
            modul.dataFiltered = Array.from(modul.dataFiltered);
          },function (result) {
            modul.dataFiltered = Array.from(modul.dataFiltered);
          })
        });
      },
      doEdit: function (e, index, headRow, dataRow) {
        const modul = this;
        this.$nextTick(() => {
          modul.modelRowIsEditing[dataRow.id] = 1
          modul.dataFiltered = Array.from(modul.dataFiltered);
        });
      },
      chkbClick: function (e, index, headRow, dataRow) {
//        const modul = this;
//        this.$nextTick(() => {
//          console.log("chkbClick data: ", e, index, headRow, dataRow);
//
//          if(typeof headRow.chkbClick ==="function"){
//            headRow.chkbClick(e, index, headRow, dataRow, rowActualState)
//            modul.dataFiltered = Array.from(modul.dataFiltered);
//          }
//        })
      },
      exportToXls(type){
        const modul = this;
        const workbook = XLSX.utils.book_new();
        const sheetManager = new OSheetManager();

        const sheetName = sheetManager.getSheetNames()[0];
        let actualSheet = sheetManager.getSheetByName(sheetName); // getSheetByName(year);

        let index = 0;
        Array.prototype.forEach.call(modul.headWithFilter, function (headRow, i2) {
          if (headRow['xlsfield']) {
            index++;
            const val = modul.$t(headRow.title);
            actualSheet["" + sheetManager.getColumnNameByNumber(index) + Number(1)] = new oCell().setValue(val).val;
          }
        });

        Array.prototype.forEach.call(modul.dataFiltered, function (e, i) {
          let index = 0;
          Array.prototype.forEach.call(modul.headWithFilter, function (e2, i2) {
            let val = void 0;
            if (e2['xlsfield']) {
              index++;
              if (e2['link']) {
                val = (e[e2['data']] === null) ? "" : e[e2['data']];
              } else if (e2['render'] && typeof e2['render'] === "function" && e2['xlsrender']) {
                let valrendered = e2['render'](e[e2['key']], "type", e, "meta");
                if (e2['xlsfieldNumber']) {
                  try {
                    val = Number(valrendered);
                  } catch (e) {
                    val = "";
                  }
                } else {
                  val = valrendered;
                }
//              val= (e[e2['key']] === null) ? "" : e[e2['key']];
              } else if (e2['key'] && e2['i18Key']) {
                val = (e[e2['key']] === null) ? "" : modul.$t(e2['i18Key'] + "." + e[e2['key']]);
              } else if (e2['key']) {
                val = (e[e2['key']] === null) ? "" : e[e2['key']];
              }
              actualSheet["" + sheetManager.getColumnNameByNumber(index) + Number(i + 2)] = new oCell().setValue(val).val;
            }

          });
        });

        console.log(actualSheet);
        workbook.Sheets = sheetManager.getSheets();
        const newSheetNames = [];
        newSheetNames.push(sheetName);
        workbook.SheetNames = newSheetNames;
        let filename = "export_data";
        XLSX.writeFile(workbook, filename + ".xlsx");

      },
      filterData(searchText){
        const modul = this;
        let data = [];
        const searchIndexes = [];
        for (let x in modul.headWithFilter) {
          if (!modul.headWithFilter.hasOwnProperty(x)) {
            continue;
          }
          if (modul.headWithFilter[x] && modul.headWithFilter[x].searchField) {
            searchIndexes.push(modul.headWithFilter[x].key);
          }
        }
        Array.prototype.forEach.call(modul.data, function (e, i) {
          let vanbenne = false;
          for (let i2 in modul.data[i]) {
            if (!modul.data[i].hasOwnProperty(i2)) {
              continue;
            }
            if (searchIndexes.length > 0) {
              if (searchIndexes.includes(i2)) {
                if (modul.data[i][i2] && modul.data[i][i2].toLowerCase && modul.data[i][i2].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                  vanbenne = true;
                }
              }
            } else {
              if (modul.data[i][i2] && modul.data[i][i2].toLowerCase && modul.data[i][i2].search && modul.data[i][i2].toLowerCase().indexOf(searchText.toLowerCase()) >= 0) {
                vanbenne = true;
              }
            }
          }
          if (vanbenne === true) {
            data.push(modul.data[i])
          }
        });
        return data;
      },
      keepsettingsChange(){
        const modul = this;
        if (modul.isKeepsettings === true) {
          modul.isKeepsettings = false;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "IsKeepsettings", false);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "perPage", modul.perPageStr);
        } else {
          modul.isKeepsettings = true;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "IsKeepsettings", true);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", modul.actualPage);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key", modul.key);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection", modul.sortDirection);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", modul.searchText);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "perPage", modul.perPageStr);
        }
      },
      keepsettingsPagerChange(){
        const modul = this;
        if (modul.isKeepsettingsPager === true) {
          modul.isKeepsettingsPager = false;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "IsKeepsettingsPager", false);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", "");
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key", "");
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection", "");
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", "");
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "perPage", modul.perPageStr);
        } else {
          modul.isKeepsettingsPager = true;
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "IsKeepsettingsPager", true);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", modul.actualPage);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key", modul.key);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection", modul.sortDirection);
//          localStorage.setItem("TableDatatableJs_" + modul.headHash + "SearchText", modul.searchText);
          localStorage.setItem("TableDatatableJs_" + modul.headHash + "perPage", modul.perPageStr);
        }
      },
      loadDefaultData(e){
        const modul = this;
        if (localStorage) {
          const isKeepsettingsPager = (localStorage.getItem("TableDatatableJs_" + modul.headHash + "IsKeepsettingsPager") === "true");
          modul.isKeepsettingsPager = isKeepsettingsPager;
          if (isKeepsettingsPager) {
            let perPage = localStorage.getItem("TableDatatableJs_" + modul.headHash + "perPage");
            if (perPage !== void 0 && perPage !== null && Number(perPage) !== "NaN" && Number(perPage) >= 0) {
                console.log(perPage)
              modul.perPageStr = String(perPage);
            }
            modul.actualPage = 1;
          }

          const isKeepsettings = (localStorage.getItem("TableDatatableJs_" + modul.headHash + "IsKeepsettings") === "true");
          modul.isKeepsettings = isKeepsettings;
          if (isKeepsettings) {
            const searchText = localStorage.getItem("TableDatatableJs_" + modul.headHash + "SearchText");
            if (searchText !== void 0 && searchText !== null) {
              modul.searchText = searchText;
            }
//            let perPage = localStorage.getItem("TableDatatableJs_" + modul.headHash + "perPage");
//            if (perPage !== void 0 && perPage !== null && Number(perPage) !== "NaN" && Number(perPage) >= 0) {
//              modul.perPageStr = String(perPage);
//            }
            let actualPage = localStorage.getItem("TableDatatableJs_" + modul.headHash + "ActualPage");
            if (actualPage !== void 0 && actualPage !== null && Number(actualPage) !== "NaN" && Number(actualPage) >= 0) {
              if (Number(actualPage) <= this.countMaxPage && Number(actualPage) > 0) {
                modul.actualPage = Number(actualPage);
              } else {
                this.actualPage = 1;
              }
            }
            let key = localStorage.getItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key");
            let sortDirection = localStorage.getItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection");
            if (key !== void 0 && key !== null && Number(key) !== "NaN" && Number(key) >= 0 && sortDirection !== void 0 && sortDirection !== null) {
              Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
                modul.$set(modul.headWithFilter[i], ['sortDirection'], void 0)
              });
              if (sortDirection !== "") {
                modul.$set(modul.headWithFilter[Number(key)], ['sortDirection'], sortDirection);
              }
            }
          }

        }
      },
      calculateCountPage(e){
        this.countMaxPage = Math.ceil(this.dataFiltered.length / this.perPage);
      },
      dataSort(arrayData, sortKey, sortType){
        return arrayData.sort(function (a, b) {
          const keyA = a[sortKey];
          const keyB = b[sortKey];
          if (sortType === "asc") {
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
          } else if (sortType === "desc") {
            if (keyA < keyB) return 1;
            if (keyA > keyB) return -1;
          }
          return 0;
        });
      },
      dataRange(from, count){
        const modul = this;
        let ret = [];
        for (let i = from; i < from + count; i++) {
          if (modul.dataFiltered.hasOwnProperty(i) && typeof modul.dataFiltered[i] !== "undefined") {
            ret.push(modul.dataFiltered[i])
            // set the modelRow for possible edit
            if (!modul.modelRow[modul.dataFiltered[i].id]) {
              modul.modelRow[modul.dataFiltered[i].id] = modul.dataFiltered[i];
            }
          }
        }
        let sortKey = void 0;
        let sortType = void 0;
        Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
          if (modul.headWithFilter[i]['sortDirection'] !== void 0) {
            sortKey = e['key'];
            sortType = e['sortDirection'];
          }
        });
        if (sortKey !== void 0 && sortType !== void 0) {
          ret = modul.dataSort(ret, sortKey, sortType);
        }

        return ret;
      },
      prev(){
        const modul = this;
        if (this.actualPage > 1) {
          this.actualPage--;
        }
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", this.actualPage)
      },
      next(){
        const modul = this;
        if (this.actualPage < this.countMaxPage) {
          this.actualPage++;
        }
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", this.actualPage)
      },
      setActualPage(i){
        const modul = this;
        this.actualPage = i;
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "ActualPage", i)
      },
      headRowClick(row, key){
        const modul = this;
        Array.prototype.forEach.call(modul.headWithFilter, function (e, i) {
          if (Number(key) !== Number(i)) {
            modul.$set(modul.headWithFilter[i], ['sortDirection'], void 0)
          }
        });
        let sortDirection = void 0;
        if (typeof modul.headWithFilter[key]['sortDirection'] === "undefined") {
          modul.$set(modul.headWithFilter[key], ['sortDirection'], "asc");
          sortDirection = "asc";
        } else if (modul.headWithFilter[key]['sortDirection'] === "asc") {
          modul.$set(modul.headWithFilter[key], ['sortDirection'], "desc");
          sortDirection = "desc";
        } else {
          modul.$set(modul.headWithFilter[key], ['sortDirection'], void 0);
          sortDirection = void 0;
        }

//        console.log(row.key, modul.headWithFilter[key]['sortDirection'])
        modul.key = key;
        modul.sortDirection = sortDirection;
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_Key", key);
        localStorage.setItem("TableDatatableJs_" + modul.headHash + "HeadWithFilter_SortDirection", sortDirection);


      },
    }
    , components: {
      InputText,
    },
  };
</script>

<style scoped>
  .DatetimepickerBpContainer {
    min-width: 200px;
  }

  .colx {
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .pagination {
    float: right
  }

  .pagination-extra > .page-link {
    background-color: rgba(0, 0, 0, .05);
  }

  .pl10 {
    padding-left: 20px !important;
  }

  .pl20 {
    padding-left: 20px !important;
  }

  /*.datatableWrapper{*/
  /*position: relative;*/
  /*top: 0;*/
  /*left: 0;*/
  /*}*/
  /*.datatableWrapperInner{*/
  /*overflow-x: scroll;*/
  /*width: 100%;*/
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 0;*/
  /*margin: 20px;*/
  /*}*/
  .datatableWrapper .table thead th {
    vertical-align: top;
    position: relative;
    top: 0;
    left: 0;
  }

  .datatableWrapper .table thead th .shorter-icon {
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 16px;*/
  }
  .datatableWrapper .shorter-icon {
    position: absolute;
    left: 2px;
    top: 16px;
  }

</style>
